export default "__VITE_PUBLIC_ASSET__0333848b__"